// renderDefaultLog.tsx

import React from 'react';
import { BaseRendererProps } from './eventRenderers';

const RenderDefaultLog: React.FC<BaseRendererProps> = ({ log }) => {
  return (
    <div className="default-event" key={log.id}>
      <h4>{log.type}</h4>
      <p>Timestamp: {log.timestamp}</p>
      <p>Sequence ID: {log.sequenceId}</p>
      <p>Details:</p>
      <ul>
        {Object.entries(log.details).map(([key, value]) => (
          <li key={key}>{`${key}: ${value}`}</li>
        ))}
      </ul>
    </div>
  );
};

export default RenderDefaultLog;
